import AttendeeStatus from "enums/AttendeeStatus";
import React, { FC } from "react";

import { useGetForumGroupsQuery } from "../../../../../../../../api/queries/groups";
import AsyncSelect from "../AsyncSelect";

interface GroupSelectingFromProps {
  forumId: number;
  primary?: boolean;
  value?: number;
  onChange?: (value: number) => void;
  orderBy?: "name" | "id" | "primary";
  orderDir?: "asc" | "desc";
}

const GroupSelectingFrom: FC<GroupSelectingFromProps> = ({
  forumId,
  primary,
  value,
  onChange,
  orderBy = "id",
  orderDir = "asc",
}) => {
  const query = useGetForumGroupsQuery({
    forumId,
    primary,
    attendeeStatuses: [AttendeeStatus.Attending, AttendeeStatus.AttendingReplacement],
    orderBy,
    orderDir,
  });

  const optionsMapper = (response: NonNullable<typeof query.data>["data"]) =>
    response.map((group) => ({
      value: group.id,
      label: group.name,
    }));

  return <AsyncSelect query={query} optionsMapper={optionsMapper} value={value} onChange={onChange} />;
};

export default GroupSelectingFrom;
